import React, { useMemo } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import classNames from 'classnames';
import useCheckIsMobile from '@/lib/hooks/useCheckIsMobile';

const ChooseContent = ({
  data,
}: {
  data?: {
    title?: string;
    imgPath?: string;
    parts?: {
      title?: string;
      desc?: string;
      imgPath?: string;
    }[];
  };
}) => {
  const { isMobile } = useCheckIsMobile();

  const getTitle = useMemo(() => {
    return data?.title ? <div className={styles.title}>{data?.title}</div> : null;
  }, [data?.title]);

  const getImage = useMemo(() => {
    return data?.imgPath ? (
      <div className="flex-center">
        <Image src={data?.imgPath} alt={''} width={100} height={100} layout="responsive" objectFit="cover" />
      </div>
    ) : null;
  }, [data?.imgPath]);

  return (
    <section className={styles.content}>
      {data?.title && <h2 className="hidden">{data?.title}</h2>}

      {isMobile && <div>{getTitle}</div>}

      <div className={styles.mainContent}>
        {getImage}
        <div className={styles.contentList}>
          {!isMobile && <div>{getTitle}</div>}

          {data?.parts?.length > 0 &&
            data?.parts?.map((item, index) => (
              <div className={styles.contentItem} key={index}>
                <div className={classNames(styles.contentItemTitle)}>
                  <Image src={item.imgPath} alt={''} width={20} height={20} />
                  <h3 className={styles.subTitle}>{item.title}</h3>
                </div>
                <p className={styles.subDesc}>{item.desc}</p>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default ChooseContent;
